import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Badge } from "../../generic/badge/Badge";
import { IdBadgePosition } from "../../generic/badge/IdBadgePosition";
import { ButtonInfoSmall } from "../../generic/common/ButtonInfoSmall";
import { componentWithProps } from "../../generic/componentWithProps";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
import { DynamicTooltip, IdTooltipAnchor } from "../../tooltip";
import { OfferGoldRewardTooltip } from "./OfferGoldRewardTooltip";
export var PaymentRewardsHeader = function (_a) {
    var title = _a.title, offer = _a.offer, totalGoldAmount = _a.totalGoldAmount, needsTooltip = _a.needsTooltip, subscriptionBonusEnabled = _a.subscriptionBonusEnabled;
    var hasSubscriptionBuff = subscriptionBonusEnabled;
    var headerFontStyle = hasSubscriptionBuff ? IdStyles.HeadlineAccent : IdStyles.HeadlineOne;
    var tooltipComponent = componentWithProps({
        ComponentType: OfferGoldRewardTooltip,
        offer: offer,
    });
    return (React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around shop__payment-reward-header-container" },
        React.createElement(TextLoca, { id: title, className: IdStyles.TextBoldPrimary + " shop__payment-reward-header-container" }),
        React.createElement(DynamicTooltip, { component: tooltipComponent, anchor: IdTooltipAnchor.Right, adjustHorizontal: -30, adjustVertical: -25, visibleOnClick: true, shouldRender: needsTooltip },
            React.createElement("div", { className: IdStyles.OfferPurchaseRewardHeaderBackground + " pos-rel flex flex--aligned flex--around" },
                needsTooltip && (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
                    React.createElement(ButtonInfoSmall, null,
                        React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall })))),
                React.createElement(Icon, { icon: IdIcon.GoldIcn, styleId: IdStyles.IconMedium }),
                React.createElement(NumberFormat, { className: headerFontStyle, format: TypeNumberFormat.None, amount: totalGoldAmount })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/PaymentRewardsHeader.tsx
// module id = 2901
// module chunks = 3